// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import CircleStarProgressBar from '@tcp/core/src/components/features/account/PlacePerks/molecules/CircleStarProgressBar';
import internalEndpoints from '@tcp/core/src/components/features/account/common/internalEndpoints';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles from '../styles/PlacePerksAccountNavHeader.style';
import AccountCommonLabels, { ACCOUNT_LABELS } from '../../../labels/AccountCommon.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';

const PlacePerksAccountNavHeader = (props) => {
  const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);

  const { className, currentPerkLevel, totalSpend, spendLeftForNextPerk } = props;
  const currentPerk = currentPerkLevel?.toLowerCase();

  const getPerkLevelText = () => {
    let currentPerkText;
    if (currentPerk === 'default' || currentPerk === undefined) {
      currentPerkText = renderLabel(
        accountLabels?.accountOverview?.lbl_placeperk_no_perk,
        'lbl_placeperk_no_perk'
      );
    } else if (currentPerk === 'plccmegastar') {
      currentPerkText = 'megastar';
    } else {
      currentPerkText = currentPerk;
    }
    return currentPerkText;
  };

  const getMaxPerkValue = () => {
    return totalSpend + spendLeftForNextPerk;
  };

  const getPercentage = () => {
    let percentage = (totalSpend / getMaxPerkValue()) * 100;
    if (percentage > 90) {
      percentage = Math.floor(percentage);
    }
    if (percentage < 10) {
      percentage = Math.ceil(percentage);
    }
    return percentage;
  };

  const getHideProgressBar = () => {
    return currentPerk === 'megastar' || spendLeftForNextPerk === 0;
  };

  const percentage = getPercentage();
  const maxPerkValue = getMaxPerkValue();
  const hideProgressBar = getHideProgressBar();
  const percentageValue = percentage === 0 ? 1 : percentage;

  return (
    <div className={`${className} place-perks-account-header`}>
      <div className="place-perks-container">
        <CircleStarProgressBar
          percentage={percentageValue}
          variant={currentPerk}
          size="small"
          earnedPerkValue={totalSpend}
          maxPerkValue={maxPerkValue}
          hideProgressBar={hideProgressBar}
          className="place-perks-progress-bar"
        />
        <div className="place-perks-text-wrapper">
          <div className="perk-level">{getPerkLevelText()}</div>
          <div>
            {renderLabel(
              accountLabels?.accountOverview?.lbl_placeperk_header,
              'lbl_placeperk_header'
            )}
          </div>
        </div>
      </div>
      <Anchor
        fontSizeVariation="xlarge"
        fontFamily="secondary"
        to={internalEndpoints.placePerks.link}
        asPath={internalEndpoints.placePerks.path}
        anchorVariation="primary"
        className="view-all-place-rewards-link"
        dataLocator="view-all-place-rewards"
        underline
      >
        {renderLabel(
          accountLabels?.accountOverview?.lbl_placeperk_view_dashboard,
          'lbl_placeperk_view_dashboard'
        )}
      </Anchor>
    </div>
  );
};

PlacePerksAccountNavHeader.propTypes = {
  className: PropTypes.string,
  labels: PropTypes.shape({}).isRequired,
  currentPerkLevel: PropTypes.string,
  totalSpend: PropTypes.number,
  spendLeftForNextPerk: PropTypes.number,
};

PlacePerksAccountNavHeader.defaultProps = {
  className: '',
  currentPerkLevel: 'default',
  totalSpend: 0,
  spendLeftForNextPerk: 0,
};

export default withStyles(PlacePerksAccountNavHeader, styles);
export { PlacePerksAccountNavHeader as PlacePerksAccountNavHeaderVanilla };
